// extracted by mini-css-extract-plugin
export default {"productsChartWrapper":"ProductsChart_productsChartWrapper__aFDXQ","productsChartPanel":"ProductsChart_productsChartPanel__1x92o","titleWrapper":"ProductsChart_titleWrapper__ajSUx"};